module.exports = __webpack_public_path__ + "static/media/variable_intro1-cy.32e5e194.svg";